export default "__VITE_ASSET__DZbKDxr0__"